import * as types from "../types";
import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { ActionsCreators } from "..";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {
    GetVideoMessagesList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary, zoneId, callCenterId, startDate, endDate) => async (dispatch, store) => {
        dispatch({ type: types.GET_VIDEMESSAGES_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/VideoMessage/OrganizationVideoMessages/" + store().currentuser.currentorganization.id + "?"
        + "pageNumber=" + pageNumber
        + "&pageSize=" + pageSize
        + (sortExpression ? "&sortExpression=" + sortExpression : "")
        + (filterExpression ? "&filterExpression=" + filterExpression : "")
        + (tagSearchRequest ? tagSearchRequest : "")
        + (zoneId ? "&zoneId=" + zoneId : "")
        + (callCenterId ? "&callCenterId=" + callCenterId : "")
        + (startDate ? "&startDate=" + startDate : "")
        + (endDate ? "&endDate=" + endDate : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            data.zoneId = zoneId;
            data.callCenterId = callCenterId;
            data.startDate = startDate;
            data.endDate = endDate;
            dispatch({ type: types.GET_VIDEMESSAGES_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    SaveVideoMessagesPagination: (paginationType) => (dispatch, store) => {
        const data = store().contents.contents;
        dispatch({ type: types.GET_VIDEMESSAGES_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },

    DeleteVideoMessage: (Id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/VideoMessage/" + Id, {
            method: "DELETE"
        }).then((data) => {
            return onSuccess();
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    ViewVideoMessage: (Id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/VideoMessage/ViewVideoMessage/" + Id, {
            method: "GET"
        }).then((data) => {
            return onSuccess();
        }).catch( (data) => {
            console.log("error", data);
        });
    },
    CheckVideoMessage: (Id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/VideoMessage/CheckVideoMessage/" + Id, {
            method: "GET"
        }).then((data) => {
            return onSuccess();
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    GetStorageList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary, startDate, endDate) => async (dispatch, store) => {
        dispatch({ type: types.GET_STORAGE_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Content/OrganizationStorage/" + store().currentuser.currentorganization.id + "?"
        + "pageNumber=" + pageNumber
        + "&pageSize=" + pageSize
        + (sortExpression ? "&sortExpression=" + sortExpression : "")
        + (filterExpression ? "&filterExpression=" + filterExpression : "")
        + (tagSearchRequest ? tagSearchRequest : "")
        + (startDate ? "&startDate=" + startDate : "")
        + (endDate ? "&endDate=" + endDate : "")
        , {
            method: "GET"
        }).then((list) => {
            const data = {};
            data.results = list;
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            data.startDate = startDate;
            data.endDate = endDate;
            dispatch({ type: types.GET_STORAGE_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    SaveStoragePagination: (paginationType) => (dispatch, store) => {
        const data = store().contents.contents;
        dispatch({ type: types.GET_STORAGE_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },

    DeleteStorage: (elementsList, onSuccess) => async (dispatch, store) => {
        const data = new FormData();
        data.append("sizeListedElementAsString", JSON.stringify(elementsList));
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Content/DeleteStorageFiles/" + store().currentuser.currentorganization.id, {
            body: data,
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.contentDeleted);
            return onSuccess();
        }).catch( (data) => {
            console.log("error", data);
            return onSuccess();
        });
    }
};
